import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const useIntersectionObserver = options => {
  const targetRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      });
    }, options);

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return [targetRef, isIntersecting];
};

useIntersectionObserver.propTypes = {
  options: PropTypes.shape({
    root: PropTypes.node,
    rootMargin: PropTypes.string,
    threshold: PropTypes.string,
  }),
};

useIntersectionObserver.defaultProps = {
  options: {
    rootMargin: '33% 0% 33%',
  },
};
